import * as yup from 'yup';

import { IInputControllerThirdStage, IThirdStageValuesCushingV2 } from './ThirdStage.types';
import { ICheckboxConfig } from '../../../../../../shared/ui/form/checkboxes/Checkboxes.types';
import { IOption } from '../../../../../../shared/ui/form/select/Select.types';

export const validationThirdStageSchema = yup.object().shape({
  treatmentOfChoivePatient: yup
    .array()
    .of(
      yup.object().shape({
        date: yup.date().required(),
        treatment: yup.string().required()
      })
    )
    .min(0)
    .ensure(),
  treatmentBeforeOperationInhibitors: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string().required(),
        dose: yup.number().required(),
        dateStart: yup
          .date()
          .nullable()
          .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
          .required(),
        dateEnd: yup
          .date()
          .nullable()
          .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
          .required()
          .min(yup.ref('dateStart'), 'Data końca musi być po początku')
      })
    )
    .min(0)
    .ensure(),
  steroidogenesisInhibitorArray: yup.array().of(
    yup.object().shape({
      type: yup.string(),
      dose: yup.number(),
      dateStart: yup
        .date()
        .nullable()
        .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null)),
      dateEnd: yup
        .date()
        .nullable()
        .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
        .min(yup.ref('dateStart'), 'Data końca musi być po początku')
    })
  ),
  operations: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string().required(),
        date: yup.date().required(),
        pituaryTumor: yup.string().required()
      })
    )
    .min(0)
    .ensure(),
  hydrocortisolTreatmentDateStart: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null)),
  hydrocortisolTreatmentDateEnd: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
    .min(yup.ref('hydrocortisolTreatmentDateStart'), 'Data końca musi być po początku'),
  pasireotideLar4WeeksDateStart: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null)),

  pasireotideLar4WeeksDateEnd: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
    .min(yup.ref('pasireotideLar4WeeksDateStart'), 'Data końca musi być po początku'),
  cabergolineDateStart: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null)),
  cabergolineDateEnd: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
    .min(yup.ref('cabergolineDateStart'), 'Data końca musi być po początku'),
  steroidogenesisInhibitorSerumArray: yup
    .array()
    .of(
      yup.object().shape({
        date: yup.date().nullable(),
        cortisol: yup.number(),
        dose: yup.number()
      })
    )
    .min(0)
    .ensure(),
  steroidogenesisInhibitorSalivaArray: yup
    .array()
    .of(
      yup.object().shape({
        date: yup.date().nullable(),
        cortisol: yup.number(),
        dose: yup.number()
      })
    )
    .min(0)
    .ensure(),
  steroidogenesisInhibitorDzmArray: yup
    .array()
    .of(
      yup.object().shape({
        date: yup.date().nullable().nullable(),
        cortisol: yup.number(),
        dose: yup.number()
      })
    )
    .min(0)
    .ensure()
});

export const initialThirdStage: IThirdStageValuesCushingV2 = {
  treatmentOfChoivePatient: [],
  treatmentBeforeOperationInhibitors: [],
  treatmentBeforeOperationInhibitorsCheckbox: false,
  operations: [],
  subnormalCortisolLevels: '',
  hydrocortisolTreatment: '',
  hydrocortisolTreatmentDateStart: null,
  hydrocortisolTreatmentDateEnd: null,
  complicationsOfSurgicalProcedures: '',
  complicationsOfSurgicalProceduresCheck: [],
  pasireotideLar4WeeksCheckbox: false,
  pasireotideLar4WeeksDose: '',
  pasireotideLar4WeeksDateStart: '',
  pasireotideLar4WeeksDateEnd: '',
  pasireotideLar4WeeksBiochemicalNormalization: '',
  pasireotideLar4WeeksCortisolDzmisActive: false,
  pasireotideLar4WeeksCortisolDzm: null,
  pasireotideLar4WeeksCortisolSalivaisActive: false,
  pasireotideLar4WeeksCortisolSaliva: null,
  pasireotideLar4WeeksCortisolSerumisActive: false,
  pasireotideLar4WeeksCortisolSerum: null,
  pasireotideLar4WeeksToleranceOfPharmacologicalTreatment: [],
  pasireotideLar4WeeksAnotherComplications: [],
  pasireotideLar4WeeksAnotherComplicationsAnother: '',
  pasireotideLar4WeeksReasonStopTreatment: '',
  pasireotideLar4WeeksAnotherComplicationsAnotherCheckbox: false,

  cabergolineCheckbox: false,
  cabergolineDose: -1,
  cabergolineDateStart: '',
  cabergolineDateEnd: '',
  cabergolineBiochemicalNormalization: '',
  cabergolineCortisolDzmisActive: false,
  cabergolineCortisolDzm: null,
  cabergolineCortisolSalivaisActive: false,
  cabergolineCortisolSaliva: null,
  cabergolineCortisolSerumisActive: false,
  cabergolineCortisolSerum: null,
  cabergolineToleranceOfPharmacologicalTreatment: [],
  cabergolineAnotherComplications: [],
  cabergolineAnotherComplicationsAnother: '',
  cabergolineReasonStopTreatment: '',
  cabergolineAnotherComplicationsAnotherCheckbox: false,
  steroidogenesisInhibitorCheckbox: false,
  steroidogenesisInhibitorArray: [],

  biochemicalNormalization: '',
  steroidogenesisInhibitorDzmCheckbox: false,
  steroidogenesisInhibitorDzmArray: [],
  steroidogenesisInhibitorSalivaCheckbox: false,
  steroidogenesisInhibitorSalivaArray: [],
  steroidogenesisInhibitorSerumCheckbox: false,
  steroidogenesisInhibitorSerumArray: [],
  toleranceOfPharmacologicalTreatment: [],
  anotherComplications: [],
  anotherComplicationsAnother: '',
  reasonStopTreatment: '',

  qualificationsDiagnosis: [],
  qualificationsDiagnosisAccess: '',

  supprotiveTreatment: [],
  improvementControl: []
};

export const checkboxInputControllerConfig: IInputControllerThirdStage = {
  hydrocortisolTreatmentDateStart: false,
  hydrocortisolTreatmentDateEnd: false,
  qualificationsDiagnosisAccess: false,
  anotherComplicationsAnother: false,
  pasireotideLar4WeeksCortisolDzm: false,
  pasireotideLar4WeeksCortisolSaliva: false,
  pasireotideLar4WeeksCortisolSerum: false,
  cabergolineCortisolDzm: false,
  cabergolineCortisolSaliva: false,
  cabergolineCortisolSerum: false,
  pasireotideLar4WeeksAnotherComplicationsAnother: false,
  cabergolineAnotherComplicationsAnother: false
};

export const typeOptions: IOption[] = [
  {
    value: 'Metyrapon',
    label: 'Metyrapon'
  },
  {
    value: 'Osilodrostat',
    label: 'Osilodrostat'
  },
  {
    value: 'Mitotan',
    label: 'Mitotan'
  },
  {
    value: 'Ketokonazol',
    label: 'Ketokonazol'
  },
  {
    value: 'Levoketokonazol',
    label: 'Levoketokonazol'
  },
  {
    value: 'Etomidat',
    label: 'Etomidat'
  }
];

export const complicationsOfSurgicalProceduresCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'GONADOTROPOWA niedoczynność przedniego płata przysadki',
    name: 'GONADOTROPOWA niedoczynność przedniego płata przysadki'
  },
  {
    label: 'KORTYKOTROPOWA niedoczynność przedniego płata przysadki',
    name: 'KORTYKOTROPOWA niedoczynność przedniego płata przysadki'
  },
  {
    label: 'TYREOTROPOWA niedoczynność przedniego płata przysadki',
    name: 'TYREOTROPOWA niedoczynność przedniego płata przysadki'
  },
  {
    label: 'SOMATOTROPOWA niedoczynności przysadki',
    name: 'SOMATOTROPOWA niedoczynności przysadki'
  }
];

export const qualificationCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'przewlekłego leczenia farmakologicznego',
    name: 'przewlekłego leczenia farmakologicznego'
  },
  {
    label: 'radioterapii',
    name: 'radioterapii'
  },
  {
    label: 'obustronnej adrenalektomii',
    name: 'obustronnej adrenalektomii'
  }
];

export const treatmentBeforeOperationPasireotidesDoseOptions: IOption[] = [
  {
    label: '10',
    value: '10'
  },
  {
    label: '20',
    value: '20'
  },
  {
    label: '30',
    value: '30'
  },
  {
    label: '40',
    value: '40'
  }
];

export const neurosurgicalTreatmentOptions: IOption[] = [
  {
    label: 'przezklinowy',
    value: 'przezklinowy'
  },
  {
    label: 'przezczaszkowego',
    value: 'przezczaszkowego'
  }
];

export const tolerationOptions: string[] = [
  'wydłużenie odstępu QTc',
  'bóle kostno-mięśniowe',
  'nudności',
  'zawroty głowy',
  'tachykardia',
  'obrzęki obwodowe',
  'nadciśnienie tętnicze',
  'hirsutyzm',
  'Inne'
];

export const tolerationCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'obserwowano objawy niedoczynności kory nadnerczy',
    name: 'obserwowano objawy niedoczynności kory nadnerczy'
  },
  {
    label:
      'obserwowano biochemiczne cechy hipokortyzolemii w trakcie leczenia (spadek kortyzolu poniżej dolnej granicy normy)',
    name: 'obserwowano biochemiczne cechy hipokortyzolemii w trakcie leczenia (spadek kortyzolu poniżej dolnej granicy normy)'
  }
];

export const otherComplicationsCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'wzrost aktywności ALT/AST',
    name: 'wzrost aktywności ALT/AST'
  },
  {
    label: 'wzrost aktywności GGTP',
    name: 'wzrost aktywności GGTP'
  },
  {
    label: 'wydłużenie odstępu QTc',
    name: 'wydłużenie odstępu QTc'
  },
  {
    label: 'kamica żółciowa nieobecna wcześniej',
    name: 'kamica żółciowa nieobecna wcześniej'
  }
];

export const supportTreatmentCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'kontroli ciśnienia tętniczego',
    name: 'kontroli ciśnienia tętniczego'
  },
  {
    label: 'kontroli glikemii',
    name: 'kontroli glikemii'
  },
  {
    label: 'profilu lipidowego',
    name: 'profilu lipidowego'
  },
  {
    label: 'regresji cech fenotypowych zespołu Cushinga',
    name: 'regresji cech fenotypowych zespołu Cushinga'
  }
];

export const convertInputControllerThirdStage = (thirdStage: IThirdStageValuesCushingV2) => {
  return {
    hydrocortisolTreatmentDateStart: thirdStage.hydrocortisolTreatmentDateStart !== null,
    hydrocortisolTreatmentDateEnd: thirdStage.hydrocortisolTreatmentDateEnd !== null,
    qualificationsDiagnosisAccess: thirdStage.qualificationsDiagnosisAccess !== '',
    anotherComplicationsAnother: thirdStage.anotherComplicationsAnother !== '',
    pasireotideLar4WeeksCortisolDzm: !!thirdStage.pasireotideLar4WeeksCortisolDzm,
    pasireotideLar4WeeksCortisolSaliva: !!thirdStage.pasireotideLar4WeeksCortisolSaliva,
    pasireotideLar4WeeksCortisolSerum: !!thirdStage.pasireotideLar4WeeksCortisolSerum,
    cabergolineCortisolDzm: thirdStage.cabergolineCortisolDzm !== null,
    cabergolineCortisolSaliva: thirdStage.cabergolineCortisolSaliva !== null,
    cabergolineCortisolSerum: thirdStage.cabergolineCortisolSerum !== null,
    pasireotideLar4WeeksAnotherComplicationsAnother: thirdStage.pasireotideLar4WeeksAnotherComplicationsAnother !== '',
    cabergolineAnotherComplicationsAnother: thirdStage.cabergolineAnotherComplicationsAnother !== ''
  };
};
